import { useCallback, useMemo, useState } from 'react';
import { PopoverPosition } from '@mui/material';
import { ViewerItem } from 'presentations/api/schema/user';

import EventPopover from 'presentations/views/components/organisms/EventPopover';
import {
  TimeListViewerCalendarEvent,
  CalendarEventListItem,
} from 'presentations/api/schema/calendar_event';
import { CalendarSourceType } from 'presentations/api/schema/calendar_event/enum';
import { UserAppItem } from 'presentations/api/schema/account';
import { useRequest } from 'presentations/views/hooks/request';
import { apiPath } from 'presentations/routes/path';
import { LocationType } from 'domains/models/event_type/locationType';
import { DisplayType } from 'domains/models/event/displayType';
import { VisibilityType } from 'domains/models/event/visibilityType';
import { Status } from 'domains/models/event/status';
import { Behavior } from 'domains/models/event/behavior';

type Props = {
  viewer: ViewerItem | null;
  timeZone: string;
};
export const useEventPopover = (props: Props) => {
  const [
    popoverPosition,
    setPopoverPosition,
  ] = useState<PopoverPosition | null>(null);
  const [
    calendarEvent,
    setCalendarEvent,
  ] = useState<TimeListViewerCalendarEvent | null>(null);

  const onClickAnchor = useCallback(
    (el: HTMLElement, event: TimeListViewerCalendarEvent) => {
      return;
      setCalendarEvent(event);

      const rect = el.getBoundingClientRect();
      setPopoverPosition({
        left: rect.left,
        top: rect.top,
      });
    },
    [],
  );

  const userAppRequest = useRequest(apiPath(`/v1/accounts/apps`));
  const userApp: UserAppItem | null = userAppRequest.data;

  const onClosePopover = useCallback(() => {
    setPopoverPosition(null);
  }, []);

  const popover = useMemo(() => {
    if (props.viewer && popoverPosition && calendarEvent) {
      const event: CalendarEventListItem = {
        calendarId: calendarEvent.calendarId,
        uid: calendarEvent.uid ?? '',
        name: calendarEvent.name,
        providerType: 0,
        description: '',
        startedAt: '',
        endedAt: '',
        isAllDay: false,
        locationId: LocationType.Custom,
        address: '',
        customLocation: null,
        timeZone: '',
        url: '',
        videoServiceType: null,
        color: calendarEvent.color ?? '',
        attendees: [],
        behavior: Behavior.Event,
        displayType: DisplayType.Private,
        visibilityType: VisibilityType.Default,
        status: Status.Open,
        isRecurringEvent: false,
      };
      return (
        <EventPopover
          viewer={props.viewer}
          isPopover
          timeZone={props.timeZone}
          mergedEvent={{
            calendarSourceType: CalendarSourceType.Integration,
            event: event,
            calendar: { id: null, name: null, color: null },
          }}
          position={popoverPosition}
          userId={calendarEvent.userId ?? ''}
          onClose={onClosePopover}
          userApp={userApp}
        />
      );
    }

    return null;
  }, [props.viewer, props.timeZone, popoverPosition]);

  return {
    state: {
      popover,
    },
    actions: {
      onClickAnchor,
    },
  };
};
